import { AbstractModule } from '@/types/modules';

import routes from './router';

export default class ProfessionalRiskModule extends AbstractModule {
  install(options: any): void {
    this.router.addRoutes(routes);
  }
}
